import styled from "styled-components";

export const LegalWrapper = styled.div`
    position: absolute;
    bottom: 4px;
    right: 8px;
`;

export const ThreeContainer = styled.div`
    position: relative;
    height: 100%;
`;

export const DimensionsWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 8px;
    margin-top: 8px;
`;

export const NoModelWarning = styled.div`
    position: absolute;
    font-size: 2em;
    width: 100%;
    top: calc(50% - 1em);
`;



// WEBPACK FOOTER //
// ./src/common/Three/Three.sc.js